import React from 'react';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import SalesmanStaticsContainer from '../../containers/salesman-statics/SalesmanStaticsContainer';

const SalesmanStaticsViewPage = () => {
  return (
    <div>
      <BreadcrumbsContainer
        title="결산관리/영업 사원별 통계"
        icon="statistics"
      />
      <SalesmanStaticsContainer />
    </div>
  );
};

export default SalesmanStaticsViewPage;
